import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Subject } from "rxjs";

export const MOCKUSER = {
  id: 1,
  nombres: "Mateo",
  apellidoP: "Casasbuenasaaaaa",
  apellidoS: "Gómez",
  email: "mateocasasbuenas@glm.edu.co",
};
export const mock = false;

const API_URL = environment.apiUrl;

@Injectable({ providedIn: "root" })
export class AccountService {
  private personasUrl: string;
  loggedUser: any;
  private subject = new Subject<any>();

  constructor(private http: HttpClient) {
    this.personasUrl = `${API_URL}/api/Personas`;
  }

  setUser(user) {
    this.loggedUser = user;
    localStorage.setItem("loggedUser", JSON.stringify(user));
    this.subject.next({ tipo: "persona-cargada", persona: this.loggedUser });
  }

  getUser() {
    return JSON.parse(localStorage.getItem("loggedUser"));
  }

  getPersona(id: string = "me") {
    return this.http.get<any>(`${API_URL}/api/Personas/${id}`);
  }

  destroyUserSession() {
    localStorage.removeItem("loggedUser");
  }

  getServiceObservable() {
    return this.subject.asObservable();
  }

  public extractData(res: any) {
    const body = res.hasOwnProperty("items") ? res.items : res;
    return body || {};
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }
}
